import './index.css'
import 'react-loading-skeleton/dist/skeleton.css'
import 'react-toastify/dist/ReactToastify.css'
import '@splidejs/react-splide/css'
import 'leaflet/dist/leaflet.css'
import 'react-tabs/style/react-tabs.css'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import MaintenancePage from 'pages/Common/maitenance'

ReactDOM.render(
  <React.StrictMode> 
     <App />
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
